import './PhoneNumberInput.scss';

import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input/input';

import Tooltip from '../../../../../shared/components/tooltips/Tooltip';
import AlertIcon from '../../../../../shared/icons/AlertIcon';

interface Props {
  phoneNumber: string;
  showError: boolean;
  errorMessage?: string | null;
  handleChange: (params: { value: any; hasError: boolean }) => void;
}

export default function PhoneNumberInput({
  phoneNumber,
  showError,
  errorMessage,
  handleChange,
}: Props) {
  const [value] = React.useState(phoneNumber ?? null);
  const [isValid, setIsValid] = React.useState(true);

  const inputClass = cx('phone-number-input input-block', {
    'input-block-error': showError && !isValid,
  });

  const onChange = (value) => {
    if (value) {
      setIsValid(isValidPhoneNumber(value));
    } else {
      setIsValid(true);
    }

    handleChange({ value: value, hasError: !isValid });
  };

  return (
    <div className={inputClass}>
      <PhoneInput
        placeholder={translate('Optional')}
        value={value}
        onChange={onChange}
        maxLength={25}
        data-testid="phoneNumber"
      />
      {showError && errorMessage && (
        <div className="input-error">
          <AlertIcon className="input-error-icon" />
          <Tooltip text={errorMessage} location="above"></Tooltip>
        </div>
      )}
    </div>
  );
}
